export default {
    page_title: "Kevi | Galeria de Arquivos",
    modal: {
        title: "Galeria de Arquivos",
        subtitle: "Selecione um arquivo existente ou envie um novo",
        clear: "Limpar",
        upload_button: "Enviar",
        filter_all: "Todos",
        filter_image: "Imagens",
        filter_video: "Videos",
        filter_audio: "Audios",
        filter_other: "Outros",
        loading_files: "Carregando arquivos...",
        empty_state: "Voce ainda nao possui nenhum arquivo. Envie o primeiro agora!",
        drop_here: "Solte aqui para enviar",
        upload_title: "Arraste e solte arquivos aqui",
        upload_subtitle: "ou clique para selecionar (max. {0}MB por arquivo)",
        upload_progress: "Progresso de upload",
        cancel: "Cancelar",
        use_file: "Usar arquivo",
        icon_pdf: "PDF",
        icon_video: "VID",
        icon_audio: "AUD",
        icon_file: "FILE",
    },
    no_files_text: "Você ainda não possui nenhum Arquivo,",
    no_files_cta: "crie o primeiro agora!",
    delete_confirm: {
        title: "Deletar Arquivo",
        question: "Tem certeza que deseja deletar o arquivo <strong>{0}</strong>?",
        warning: "Caso ele esteja sendo utilizado em alguma ação, a imagem não será exibida.",
        irreversible: "Esta ação não pode ser desfeita.",
    },
    search_placeholder: "Filtrar por Nome do Arquivo",
    upload_area: "Clique para upload ou arraste e solte arquivos aqui",
    copy_url: "Copiar URL",
    delete_button: "Excluir",
    no_results_search: "Nenhum arquivo encontrado com <strong>{0}</strong>",
    no_results_filter: "Nenhum arquivo encontrado com este filtro",
    ai: {
        create_title: "Criar imagem com KeviAI",
        edit_title: "Editar imagem com KeviAI",
        back: "Voltar",
        edit_prompt_label: "O que voce quer mudar na imagem?",
        create_prompt_label: "Descreva a imagem",
        prompt_placeholder: "Ex: Um cafe aconchegante com luz suave, estilo fotografia profissional",
        improve_prompt: "Melhorar prompt",
        generate_edit: "Gerar edicao",
        improved_prompt_label: "Prompt melhorado (voce pode editar)",
        choose_style: "Escolher estilo",
        choose_style_label: "Escolha um estilo visual",
        generate_image: "Gerar imagem",
        generating: "Gerando imagem...",
        adjust: "Ajustar",
        save_to_gallery: "Salvar na galeria",
        preview: "Pre-visualizacao",
        select_file: "Selecione um arquivo",
        preview_generated_here: "A imagem gerada aparecera aqui",
        edit_with_keviai: "Editar com KeviAI",
        back_to_gallery: "Voltar para galeria",
        use_image: "Usar imagem",
        image_saved: "Imagem salva na galeria!",
        error_improve_prompt_unavailable: "Nao foi possivel melhorar o prompt.",
        error_improve_prompt: "Erro ao melhorar o prompt. Tente novamente.",
        error_generate_image_unavailable: "Nao foi possivel gerar a imagem.",
        error_generate_image: "Erro ao gerar a imagem. Tente novamente.",
        error_edit_image_unavailable: "Nao foi possivel editar a imagem.",
        error_edit_image: "Erro ao editar a imagem. Tente novamente.",
        error_save_image: "Erro ao salvar imagem na galeria.",
        style: {
            realistic_title: "Fotografia realista",
            realistic_description: "Iluminacao natural, detalhes nitidos, aparencia fotografica.",
            studio_title: "Produto em estudio",
            studio_description: "Fundo limpo, sombras suaves, foco no produto.",
            illustration_title: "Ilustracao",
            illustration_description: "Tracos artisticos, visual desenhado, cores equilibradas.",
            watercolor_title: "Aquarela",
            watercolor_description: "Texturas suaves, pinceladas e tons aquarelados.",
            three_d_title: "3D",
            three_d_description: "Render 3D, volumetria, materiais realistas.",
            minimal_title: "Minimalista",
            minimal_description: "Poucos elementos, composicao limpa, cores simples.",
        },
    },
    filter_label: "Tipo de Arquivo",
    filter_options: {
        image: "Imagem",
        pdf: "PDF",
        video: "Vídeo",
        audio: "Áudio",
        other: "Outro",
    },
    notifications: {
        url_copied: "URL copiada com sucesso!",
        url_copy_error: "Nao foi possivel copiar a URL.",
        upload_success: "Arquivo(s) enviado(s) com sucesso!",
        upload_error_title: "Erro ao enviar arquivo(s)!",
        upload_error_message: "Erro ao enviar arquivo(s), tente novamente mais tarde!",
        oversized_files: "Arquivos com mais de 20MB:",
        load_error: "Erro ao carregar arquivos. Tente novamente.",
        delete_success: "Arquivo deletado com sucesso!",
        delete_error: "Erro ao deletar arquivo. Tente novamente.",
    },
};
